import { QueryClient } from '@tanstack/react-query';

// Create a single QueryClient instance that can be imported by both
// index.js (for the Provider) and authStore (for clearing cache)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
});

export default queryClient;
